import { CloseCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
const Container = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 250px;
  margin: 40px;
`;
const Heading = styled.h3 `
  font-size: 16px;
`;
const StyledCloseCircleOutlined = styled(CloseCircleOutlined) `
  color: ${({ theme }) => theme.colors.coral};
`;
const StyledInfoCircleOutlined = styled(InfoCircleOutlined) `
  color: ${({ theme }) => theme.colors.sudoBlue};
`;
const HelpText = styled.p `
  font-size: 14px;
  text-align: center;
`;
const TechInfo = styled.span `
  font-family: monospace;
  font-size: 0.9em;
`;
export const ReloadLink = styled.a `
  color: ${({ theme }) => theme.colors.sudoBlue};
`;
export const GeneralRequestError = (props) => (React.createElement(Container, null,
    React.createElement(Heading, null,
        React.createElement(StyledCloseCircleOutlined, null),
        " There was trouble loading",
        ' ',
        props.dataType || 'the',
        " data."),
    React.createElement(HelpText, null,
        "Please check your connection and",
        ' ',
        React.createElement(ReloadLink, { onClick: (event) => {
                event.preventDefault();
                window.location.reload();
            } }, "reload the page."))));
export const NotImplemented = (props) => (React.createElement(Container, null,
    React.createElement(Heading, null,
        React.createElement(StyledInfoCircleOutlined, null),
        " Not implemented"),
    React.createElement(HelpText, null,
        "A report has not yet been implemented yet for",
        ' ',
        React.createElement(TechInfo, null, props.reportField),
        ".")));
export const NotAvailable = () => (React.createElement(Container, null,
    React.createElement(Heading, null,
        React.createElement(StyledInfoCircleOutlined, null),
        " The report cannot be loaded"),
    React.createElement(HelpText, null,
        "This project does not have analytics support enabled.",
        React.createElement("br", null),
        React.createElement(TechInfo, null, "RD_ANALYTICS_ENABLED=false"))));
export const ChartRequestError = (props) => props.error?.errorType === 'NOT_IMPLEMENTED' ? (React.createElement(NotImplemented, { ...props })) : props.error?.errorType === 'NOT_AVAILABLE' ? (React.createElement(NotAvailable, { ...props })) : (React.createElement(GeneralRequestError, { ...props }));
